import React, { useEffect, useState } from 'react';
import lodash from 'lodash';
import styles from './StudyDocuments.scss';
import { RecommendationMessage } from './../StudyExpectations';
import { STUDY_DOCUMENTS_RECOMMENDATIONS } from 'common/util/studyHelpers.js';
import {
    CardControls, CardExpectationDocuments,
    CardLabels,
    DisabledCardTooltip,
} from './common/shareComponent';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { manageStudyExpectationsPredicate } from 'common/permissions/studyPredicates';
import { Conditional } from 'common/components/layout';


export function StudyExpectationsStudyDocuments(props) {
    const {
        expectedStudyDocuments,
        binderId,
        openFilePicker,
        onError,
        onFile,
        setUploadedFileToExpectation,
        manageStudyExpectations,
        studyId,
    } = props;

    const [unfolded, setUnfolded] = useState(new Array(expectedStudyDocuments.length).fill(false));

    if (lodash.isEmpty(expectedStudyDocuments)) {
        return <RecommendationMessage currentStage={props.studyStage} message={STUDY_DOCUMENTS_RECOMMENDATIONS} />;
    }

    const setListItem = value => {
        setUnfolded(
            unfolded.map((unfold, index) => {
                return (index === value)
                    ? !unfold
                    : unfold;
            })
        );
    };

    useEffect(() => {
        if (!!expectedStudyDocuments && expectedStudyDocuments.length > 0) {
            setUnfolded(unfolded => {
                return expectedStudyDocuments.reduce((acc, curr) => {
                    acc.push(curr.uploaded ? true : false);
                    return acc;
                }, []);
            });
        }
    }, [expectedStudyDocuments]);

    const cards = expectedStudyDocuments.map((expectation, index) => {
        const hasUploadedDocuments = !!expectation.uploaded;
        const hasFiledDocuments = expectation.documents && expectation.documents.length > 0;
        const documentStatus = getDocumentStatus(expectation);
        const documentAccess = expectation.documentAccess;
        const hasDocument = hasUploadedDocuments || hasFiledDocuments;
        const cardClassNames = classnames({
            [styles.disabledCard]: !documentAccess,
            [styles.expectationCard]: documentAccess
        });
        return (
            <Conditional condition={manageStudyExpectations || documentAccess} data-cy="StudyDocuments">
                <li key={expectation.id} className={cardClassNames} data-cy={'StudyDocuments' + expectation.id}>
                    <DisabledCardTooltip hasDocumentAccess={documentAccess} />
                    <div className={styles.expectationDetails} data-cy={'StudyDocuments-div' + expectation.id}>
                        <CardLabels
                            cardTitle={expectation.name}
                            cardStatus={documentStatus.status}
                        />
                        <CardControls
                            expectation={expectation}
                            setUploadedFileToExpectation={setUploadedFileToExpectation}
                            openFilePicker={openFilePicker}
                            unfolded={unfolded[index]}
                            onClick={
                                () => setListItem(index, expectation)
                            }
                        />
                    </div>
                    <Conditional condition={unfolded[index]}>
                        <CardExpectationDocuments
                            expectation={expectation}
                            binderId={binderId}
                            onError={onError}
                            onFile={onFile}
                            studyId={studyId}
                            filteredUploadedDocuments={expectation.uploaded}
                            filteredDocuments={expectation.documents}
                            hasDocument={hasDocument}
                        />
                    </Conditional>
                </li>
            </Conditional>
        );
    });

    return <ul className={styles.expectationCards} data-cy="StudyDocuments-cards">{cards}</ul>;
}



export const getDocumentStatus = (expectation) => {
    return expectation.status.find(status => status.studyTeamMemberId === null);
};

export default connect(state => {
    const manageStudyExpectations = manageStudyExpectationsPredicate(state);
    return {
        studyId: lodash.get(state, 'study.id'),
        manageStudyExpectations
    };
})(StudyExpectationsStudyDocuments);
